const countPages = (limit, count) => {
    return Math.ceil(count / limit, 10)
}
export default countPages
